import React, { FunctionComponent, memo } from "react";
import { useIntl } from "react-intl";
import { isEqual } from "lodash";

import { PlcBattery } from "./types";

import Source from "./components/Source";
import SourceMetric from "./components/SourceMetric";


interface IProps {
  data: PlcBattery;
}


const SourceBattery: FunctionComponent<IProps> = memo(function SourceBattery({
  data,
}) {
  const intl = useIntl();

  return <>
    <Source
      name={intl.formatMessage({
        id: "site__control__battery__name",
        defaultMessage: "Battery",
      })}
      offline={!data}
      {...data}
    >
      {data && <>
      <SourceMetric
        secondary
        name={intl.formatMessage({
          id: "site__control__battery__metric_soc",
          defaultMessage: "Capacity",
        })}
        value={data.metrics?.pct_charge}
        unit="%"
      />
      <SourceMetric
        name={intl.formatMessage({
          id: "site__control__battery__metric_soh",
          defaultMessage: "Health",
        })}
        value={data.metrics?.pct_health}
        unit="%"
      />
      <SourceMetric
        name={intl.formatMessage({
          id: "site__control__battery__metric_temperature",
          defaultMessage: "Temperature",
        })}
        value={data.metrics?.c_temperature}
        unit="°C"
      />
      </>}
    </Source>
  </>
}, isEqual);

export default SourceBattery;
